import KeyCollection from './key_collection';

export default KeyCollection;
